<template><WorkspaceSites configuration /></template>
<script setup>
import WorkspaceSites from '../ai/WorkspaceSites.vue'
</script>
